<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-briefcase"></i>
                    <span>{{$t('dashboard.references.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!referenceItems.length" class="panel--empty">
                    <center>{{$t('dashboard.references.no_experience')}}</center>
                </div>
                <div v-else class="panel__list">
                    <reference-item v-for="item in referenceItems" :key="item.id" :item="item" />
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.references.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.references.see_all')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ReferenceItem from './ReferenceItem';

    @Component({
        components: {
            ReferenceItem,
        }
    })
    export default class ReferencePanel extends Vue {
        name = 'reference-panel';
        expanded = false;

        get referenceItems() {
            return this.$store.state.profile.profile.references || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.referenceItems.length && this.referenceItems.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/ReferencePanel.vue